/* tslint:disable max-classes-per-file */
// tslint:disable-next-line:no-submodule-imports
import compose from 'lodash/fp/compose';
import React from 'react';

interface WithTrackingProps {
  forwardedRef?: any;
  location: Location;
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

// Get page name from URL
function getPageName(location = { pathname: '/' }) {
  const { pathname } = location;
  let page = 'Home';
  if (pathname.startsWith('/blog')) {
    page = 'Blog';
  } else if (pathname !== '/') {
    page = pathname.substr(1, 1).toUpperCase() + pathname.substr(2);
  }

  // Remove any slashes
  return page.replace(/\//g, '');
}

const withTracking = <P extends object>(Component: React.ComponentType<P>) => {
  class WithTracking extends React.Component<P & WithTrackingProps> {
    public displayName = `WithTracking(${getDisplayName(Component)}`;

    public render() {
      const { forwardedRef, location, ...props } = this.props;

      // Add `track()` method to component
      const track = (name: string, useComponentName: string) => {
        const page = getPageName(location || { pathname: '/' });
        const eventName = String(name).replace(/\s+/g, '');
        const composedEventName = `M_${page}_${useComponentName || getDisplayName(Component)}-${eventName}`;
        if (!['app.kindur.com', 'www.kindur.com'].includes(document.location.hostname)) {
          console.log(`tracking event "${composedEventName}"`);
        }
        // @ts-ignore
        if (window.analytics && window.analytics.track) {
          // @ts-ignore
          window.analytics.track(composedEventName, window.testEventProps);
        }
      };

      return <Component ref={forwardedRef} location={location} track={track} {...(props as P)} />;
    }
  }

  return React.forwardRef((props, ref) => {
    // @ts-ignore
    return <WithTracking {...props} forwardedRef={ref} />;
  });
};

/* tslint:enable max-classes-per-file */
export default compose(
  withTracking
);
